import { useState } from 'react';
import { ChevronDown, ChevronRight, Clock, Lock } from 'lucide-react';
import useBoardStore from '../../../store/boardStore';

export default function RecentSection({ activeBoardId, onNavigate }) {
  const { recentBoardIds, boards, favoriteFolders } = useBoardStore();
  const [expanded, setExpanded] = useState(true);

  // resolve nome: primeiro em boards, fallback nos boards dentro de favoritos
  const byId = new Map();
  for (const b of boards) byId.set(b.id, b);
  for (const f of favoriteFolders) {
    for (const b of f.boards || []) if (!byId.has(b.id)) byId.set(b.id, b);
  }
  const items = recentBoardIds.map((id) => byId.get(id)).filter(Boolean).slice(0, 3);

  if (items.length === 0) return null;

  return (
    <div className="mb-3">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center gap-1 px-4 py-1.5 text-xs font-semibold text-text-secondary uppercase tracking-wider hover:text-text-primary transition-colors"
      >
        {expanded ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronRight className="w-3.5 h-3.5" />}
        Visualizado recentemente
      </button>
      {expanded && (
        <div>
          {items.map((b) => (
            <button
              key={b.id}
              onClick={() => onNavigate(`/board/${b.id}`)}
              className={`w-full flex items-center gap-2 px-4 py-1.5 pl-9 text-sm cursor-pointer transition-colors ${
                b.id === activeBoardId
                  ? 'text-text-primary bg-white/10'
                  : 'text-text-secondary hover:text-text-primary hover:bg-white/5'
              }`}
            >
              <Clock className="w-3 h-3 shrink-0 text-text-secondary/60" />
              <span className="truncate text-left flex-1">{b.name}</span>
              {/* Cadeado de "pede senha para abrir", igual as listas de area e
                  de favoritos. Os itens daqui saem de `boards` e dos
                  favoritos, que ja trazem is_protected — nao ha nada a
                  buscar. */}
              {b.is_protected && (
                <Lock className="w-3 h-3 shrink-0 text-text-secondary/70" title="Pede senha para abrir" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
